import { AllowListProp } from "./PropsFilterSelect";

export default function hasValueIntersection(
  a: Set<AllowListProp>,
  b: Set<AllowListProp>
): boolean {
  if (a.size === 0 || b.size === 0) {
    return false;
  }

  const aValues = new Set([...a].map((p) => p.value));
  const bValues = new Set([...b].map((p) => p.value));

  if (aValues.size < bValues.size) {
    for (let aVal of aValues) {
      if (bValues.has(aVal)) {
        return true;
      }
    }
  } else {
    for (let bVal of bValues) {
      if (aValues.has(bVal)) {
        return true;
      }
    }
  }

  return false;
}
